export default __webpack_public_path__ + "static/media/user.7cc62d57.png";